import { useMemo, useState, useCallback } from "react";

import {
  Text,
  Heading,
  Stack,
  FormControl,
  FormHelperText,
  VStack,
  HStack,
  CircularProgress,
  useUpdateEffect,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";

import { useHistory } from "react-router-dom";

// components
import Button from "components/Button/Button";
// import Select from "components/Select/Select";
import InputWithSelect from "components/Input/InputWithSelect";
import Preview from "components/Modals/swap/SwapPreview";

// import SuccessModal from "components/Modals/Success";

// import { useGetRateQuery } from "services/rateApi";
import {
  useBuyCryptoMutation,
  useBuyCryptoRateMutation,
} from "services/swapApi";

// hooks
import useWalletBalance from "hooks/useWalletBalance";

// utils
// import debounce from "lodash/debounce";
import toUpper from "lodash/toUpper";
import uniqBy from "lodash/uniqBy";
import constants from "config/constant";
import toCoinLocale from "util/toCoinLocale";
import formatter from "util/formatter";
import selectCountryCurrency from "util/selectCountryCurrency";
import toPrecision from "util/toPrecision";
import SuccessModal from "components/Modals/Success";
import getError from "util/getError";
import useRedebounce from "hooks/useDebounce";

export default function BuyNow(props) {
  // const fee = 0.1;
  const { userData } = props;

  const toast = useToast();
  const history = useHistory();

  const {
    isOpen: isPreviewOpen,
    onOpen: onPreviewOpen,
    onClose: onPreviewClose,
  } = useDisclosure();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const defaultUserCurrency = useMemo(
    () => selectCountryCurrency(userData?.country),
    [userData?.country]
  );

  const [state, _set] = useState({
    selectedCoin: null /*isProd ? "btc" : "tbtc",*/,
    selectedFiatWallet: defaultUserCurrency ?? "ngn",
  });

  const set = useCallback(
    (newState) => _set((state) => ({ ...state, ...newState })),
    []
  );

  const coinMap = useCallback((token) => {
    const map = {
      [token]: token,
      tbtc: "btc",
      teth: "eth",
      ceur: "eur",
    };

    return map[token ?? "tbtc"];
  }, []);

  const ticker = useMemo(() => {
    const coin = constants.stableCoins.includes(state?.selectedCoin)
      ? "usd"
      : state.selectedCoin;

    return `${coinMap(coin)}${state.selectedFiatWallet}`;
  }, [state.selectedCoin, state.selectedFiatWallet, coinMap]);

  const { getBalance, cryptos, isLoading } = useWalletBalance();

  // const { data: rateData, isFetching: isRating } = useGetRateQuery(ticker);
  // const rate = useMemo(() => rateData?.exchangeRate?.buy, [rateData]);

  // const rate = 25815465; // tbtc
  // const rate = 540; // usd

  const [
    _buyCrypto,
    { data: swapData, isLoading: isBuying, isSuccess, isError, error },
  ] = useBuyCryptoMutation();

  const [_buyCryptoRate, { data: buyRate, isLoading: isLoadingRate }] =
    useBuyCryptoRateMutation();

  const rate = useMemo(() => buyRate?.rate, [buyRate]);
  const fee = useMemo(() => buyRate?.fee, [buyRate]);

  console.log("BUY RATE", rate);

  const buyCrypto = () => {
    const reqData = {
      coin: state?.selectedCoin,
      currency: state?.selectedFiatWallet,
      price: state?.fiatAmount,
      buyPrice: state?.rate,
      ticker,
    };

    console.log("REQ DATA", reqData);

    onPreviewClose();
    _buyCrypto({ ...reqData });
  };

  const checkBuyRate = (price) => {
    const reqData = {
      coin: state?.selectedCoin,
      currency: state?.selectedFiatWallet,
      buyPrice: +price,
      price: +price,
      ticker,
    };

    _buyCryptoRate({ ...reqData });
  };

  // const debouncedValue = useCallback(debounce(state?.fiatAmount, 500), [
  //   state?.fiatAmount,
  // ]);

  //   console.log("RATE DATA", rateData, ticker);

  const redebounce = useRedebounce();

  const swapFee = useMemo(
    () => +state?.fiatAmount * (fee ?? 0),
    [state?.fiatAmount, fee]
  );

  const finalQuantity = useMemo(
    () => ((+state?.fiatAmount ?? 0) - swapFee) / rate,
    [state?.fiatAmount, rate, swapFee]
  );

  console.log("swapFee", swapFee);

  const coins = useMemo(
    () =>
      uniqBy(cryptos, "coin")
        .map((crypto) => crypto.coin)
        .filter((coin) => coin !== "usdt-tron"),
    [cryptos]
  );

  const balance = useMemo(
    () => getBalance(state?.selectedFiatWallet),
    [state?.selectedFiatWallet, getBalance]
  );

  const isInsufficientFunds = useMemo(
    () => +state?.fiatAmount > +balance,
    [state?.fiatAmount, balance]
  );

  const isDisabled = useMemo(
    () =>
      !(
        state?.fiatAmount &&
        state?.coinAmount &&
        state?.selectedCoin &&
        state?.selectedFiatWallet
      ) ||
      isInsufficientFunds ||
      isLoadingRate ||
      isLoading ||
      isBuying,
    [state, isInsufficientFunds, isLoadingRate, isLoading, isBuying]
  );

  const handleFiatWalletChange = (e) => {
    set({
      selectedFiatWallet: e.target.value,
      changeRef: "fiat",
    });
  };

  const handleCoinChange = (e) => {
    set({
      selectedCoin: e.target.value,
      changeRef: "coin",
    });
  };

  const handleFiatAmount = (value) => {
    set({ fiatAmount: value, changeRef: "fiat" });
    // debounceFn(value);
    redebounce(() => checkBuyRate(value), "checkBuyRate", 500)();
  };

  const handleCoinAmount = (value) => {
    set({ coinAmount: value, changeRef: "coin" });
    redebounce(() => checkBuyRate(1), "checkBuyRate", 500)();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onPreviewOpen();
  };

  const handleSuccessModalClose = () => {
    onClose();
    history.push(`/dashboard/wallet/${state?.selectedCoin}`);
  };

  // useUpdateEffect(() => , [state?.fiatAmount]);

  useUpdateEffect(() => {
    // checkBuyRate();

    if (rate && state?.fiatAmount && state?.changeRef === "fiat") {
      set({ rate, coinAmount: parseFloat(state?.fiatAmount) / rate });
    }
    if (rate && state?.coinAmount && state?.changeRef === "coin") {
      set({ rate, fiatAmount: parseFloat(state?.coinAmount) * rate });
    }
  }, [rate, state?.fiatAmount, state?.coinAmount, state?.changeRef]);

  useUpdateEffect(() => {
    if (isSuccess && swapData) {
      onOpen();
    }

    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, error, swapData, isError, onOpen, toast, onPreviewClose]);

  return (
    <>
      {isLoading && (
        <VStack mt="40px">
          <CircularProgress
            disabled
            isIndeterminate
            color="#a7a7a7"
            size="32px"
          />

          {/* {!isLoading && isEmpty(earnings) && <Text>History not found</Text>} */}
        </VStack>
      )}

      {!isLoading && (
        <Stack as="form" mt="20px" onSubmit={handleSubmit}>
          <Heading as="h5" fontSize="lg" mb="10px !important">
            Buy Calculator
          </Heading>
          <FormControl mb="10px !important">
            <InputWithSelect
              isError={isInsufficientFunds}
              isMaxing={
                isLoadingRate || isLoading
                // && state.changeRef === "coin"
              }
              onMax={() => {
                handleFiatAmount(Math.floor(balance));
              }}
              selectValue={state?.selectedFiatWallet ?? ""}
              inputValue={state?.fiatAmount ?? ""}
              onSelect={handleFiatWalletChange}
              onInput={handleFiatAmount}
              _inputContainer={{ flex: 0.81 }}
              _selectContainer={{ flex: [0.3, 0.25, 0.19] }}
              _select={{ placeholder: "Select" }}
              _input={{ disabled: !state?.selectedCoin }}
            >
              {constants?.fiats.map((fiat) => (
                <option key={`fiat-${fiat}`} value={fiat}>
                  {toUpper(fiat)}
                </option>
              ))}
            </InputWithSelect>

            {isInsufficientFunds && (
              <FormHelperText color="red.400">
                Insufficient funds
              </FormHelperText>
            )}
          </FormControl>

          <FormControl>
            <InputWithSelect
              //   isMaxing={
              //     state.isCalculating && state.changeRef === "fiat"
              //   }
              // onMax={() => {
              //   handleCoinAmount(
              //     Number(
              //       getBalance(state.selectedCoin)
              //     ).toPrecision(6)
              //   );
              // }}
              onSelect={handleCoinChange}
              defaultSelectValue="cusd"
              selectValue={state.selectedCoin ?? ""}
              inputValue={state.coinAmount ?? ""}
              onInput={handleCoinAmount}
              _input={{ name: "coinAmount" }}
              _inputContainer={{ flex: 0.81 }}
              _selectContainer={{ flex: [0.3, 0.25, 0.19] }}
              _select={{ placeholder: "Select" }}
            >
              {coins?.map((coin) => (
                <option value={coin}>{toCoinLocale(coin)}</option>
              ))}
            </InputWithSelect>

            {state?.selectedFiatWallet && (
              <FormHelperText mt="16px" fontWeight="500">
                <HStack>
                  <Text>Available Balance:</Text>
                  <Text ml="4px !important" color="var(--primary)">
                    {formatter(state.selectedFiatWallet).format(+balance)}
                  </Text>
                </HStack>
              </FormHelperText>
            )}
          </FormControl>

          <VStack mt="60px !important">
            <Button
              minH="60px"
              w="200px"
              disabled={isDisabled}
              isLoading={isBuying}
              type="submit"
            >
              Buy
            </Button>
          </VStack>

          <Preview
            isOpen={isPreviewOpen}
            onClose={onPreviewClose}
            title="Buy Summary"
            buttonText={["Close", "Buy"]}
            onConfirm={buyCrypto}
            data={{
              [`${toCoinLocale(state?.selectedCoin)} Quantity`]: toPrecision(
                state?.coinAmount,
                state?.selectedCoin,
                true,
                8,
                true
              ),
              [`Final ${toCoinLocale(state?.selectedCoin)} Quantity`]:
                toPrecision(finalQuantity, state?.selectedCoin, true, 8, true),
              [`Fees (${fee}%)`]: toPrecision(
                swapFee,
                state?.selectedFiatWallet,
                true,
                2,
                true
              ),
              Amount: formatter(state?.selectedFiatWallet).format(
                state?.fiatAmount
              ),
            }}
          />

          <SuccessModal
            isOpen={isOpen}
            onClose={handleSuccessModalClose}
            title="Success"
            message="Purchase Successful!"
          />
        </Stack>
      )}
    </>
  );
}
